import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bcc4f1d&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5bcc4f1d&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=5bcc4f1d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc4f1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcc4f1d')) {
      api.createRecord('5bcc4f1d', component.options)
    } else {
      api.reload('5bcc4f1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bcc4f1d&scoped=true&lang=pug", function () {
      api.rerender('5bcc4f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/navigation/index.vue"
export default component.exports